var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 167,
    viewBox: "0 0 289 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.793 162.434L7.12377 73.1359C3.31929 70.9394 3.31956 67.3655 7.12404 65.169L113.1 3.98357C116.905 1.78705 123.095 1.78689 126.899 3.98341L281.569 93.2817C285.373 95.4782 285.373 99.0524 281.569 101.249L175.592 162.434C171.788 164.631 165.597 164.631 161.793 162.434Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.79 4.6237C122.598 2.7803 117.402 2.7803 114.209 4.62386L8.23306 65.8093C5.03993 67.6528 5.03993 70.6523 8.23279 72.4957L162.902 161.794C166.095 163.637 171.29 163.638 174.483 161.794L280.46 100.609C283.653 98.765 283.653 95.7654 280.46 93.922L125.79 4.6237ZM161.793 162.434L7.12377 73.1359C3.31929 70.9394 3.31956 67.3655 7.12404 65.169L113.1 3.98357C116.905 1.78705 123.095 1.78689 126.899 3.98341L281.569 93.2817C285.373 95.4782 285.373 99.0524 281.569 101.249L175.592 162.434C171.788 164.631 165.597 164.631 161.793 162.434Z",
    fill: "#A7A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.025 109.861L97.926 13.386C97.6199 13.2093 97.6199 12.9224 97.926 12.7457C98.232 12.569 98.7289 12.569 99.035 12.7457L266.134 109.22C266.44 109.397 266.44 109.684 266.134 109.861C265.828 110.037 265.331 110.037 265.025 109.861Z",
    fill: "#A7A7A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.822 18.0182C132.428 17.2135 130.16 17.2135 128.766 18.0182C127.372 18.8231 127.372 20.1323 128.766 20.937C130.16 21.7417 132.428 21.7418 133.822 20.937C135.215 20.1323 135.215 18.8229 133.822 18.0182ZM127.657 21.5773C125.652 20.4195 125.652 18.5357 127.657 17.3779C129.663 16.2201 132.925 16.2201 134.931 17.3779C136.936 18.5357 136.936 20.4195 134.931 21.5773C132.925 22.7351 129.663 22.7351 127.657 21.5773Z",
    fill: "#A7A7A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.315 24.0764C142.921 23.2717 140.653 23.2715 139.259 24.0762C137.865 24.8811 137.866 26.1905 139.26 26.9951C140.653 27.7998 142.921 27.8 144.315 26.9951C145.709 26.1905 145.709 24.8811 144.315 24.0764ZM138.151 27.6354C136.145 26.4776 136.145 24.5937 138.15 23.4359C140.156 22.2781 143.419 22.2783 145.424 23.4361C147.43 24.5939 147.43 26.4776 145.424 27.6354C143.419 28.7932 140.156 28.7932 138.151 27.6354Z",
    fill: "#A7A7A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.883 15.1988C122.181 16.1817 119.421 16.1815 117.719 15.1988C116.016 14.216 116.016 12.6226 117.719 11.6398C119.421 10.6569 122.181 10.6569 123.883 11.6398C125.585 12.6225 125.585 14.216 123.883 15.1988Z",
    fill: "#FF6600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.329 11.9598C121.935 11.1551 119.667 11.1551 118.273 11.9598C116.879 12.7646 116.879 14.0738 118.273 14.8785C119.667 15.6832 121.934 15.6834 123.329 14.8785C124.722 14.0738 124.722 12.7644 123.329 11.9598ZM117.164 15.5188C115.159 14.361 115.159 12.4773 117.164 11.3195C119.169 10.1617 122.432 10.1617 124.438 11.3195C126.443 12.4773 126.443 14.361 124.438 15.5188C122.432 16.6766 119.169 16.6766 117.164 15.5188Z",
    fill: "#A7A7A7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1653_67047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.192 75.3909C152.996 83.5871 129.978 83.5871 115.782 75.3909C101.585 67.1946 101.585 53.9053 115.782 45.709C129.978 37.5125 152.996 37.5125 167.193 45.7088C181.389 53.905 181.389 67.1944 167.192 75.3909Z",
    fill: "#0889C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.638 55.4407L144.219 48.7545L148.458 57.8878L152.696 67.0215L136.877 64.574L121.057 62.1267L132.638 55.4407Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1653_67047",
    x: 75.9449,
    y: 30.8678,
    width: 131.084,
    height: 93.4452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.95
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.06562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.427171 0 0 0 0 0.629167 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1653_67047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1653_67047",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMode);
export default __webpack_public_path__ + "static/media/video-mode.9a998db5e895dd7f0dec233582926f3c.svg";
export { ForwardRef as ReactComponent };